<ejs-grid #grid
          class="grid-with-toolbar"
          width='100%'
          rowHeight='38'
          [dataSource]="data"
          [allowFiltering]='true'
          [filterSettings]='filterSettings'
          [allowSorting]='true'
          [pageSettings]='pageSettings'
          [allowPaging]='true'
          [editSettings]="editSettings"
          [filterSettings]="filterOptions"
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)"
          (rowDataBound)="onRowDataBound($event)">
  <ng-template #toolbarTemplate let-data>
    <ejs-toolbar>
      <e-items>
        <e-item [text]="(isEditModeEqualsEntry ? 'i18n.domain.settings.email-settings.entry' : 'i18n.domain.settings.email-settings.exit') | translate" prefixIcon='e-icons icon-add' (click)="addConfiguration()"></e-item>
      </e-items>
    </ejs-toolbar>
  </ng-template>
  <e-columns>
    <e-column headerText='id' field='id' [visible]='false' [isPrimaryKey]='true'></e-column>
    <e-column headerText="direction" field="direction" [visible]='false'></e-column>
    <e-column [headerText]="'i18n.domain.settings.email-settings.name' | translate" field="accountName" clipMode='EllipsisWithTooltip'></e-column>
    <e-column [headerText]="'i18n.domain.settings.email-settings.type' | translate" field="accountType" clipMode='EllipsisWithTooltip' [filter]="typeFilter">
      <ng-template #filterItemTemplate let-data>{{formatFilterType(data)}}</ng-template>
      <ng-template #template let-data>
        {{'i18n.shared.email-account-type.' + EmailAccountType[data.accountType] | translate}}
      </ng-template>
    </e-column>
    <e-column [headerText]="'i18n.domain.settings.email-settings.email' | translate" field="emailAddress" clipMode='EllipsisWithTooltip'></e-column>
    <e-column headerText="" [commands]='gridCommands' width='120px'></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-email-settings-edit-form [emailEditForm]="gridEditForm" [isEditModeEqualsEntry]="isEditModeEqualsEntry"></app-email-settings-edit-form>
  </ng-template>
</ejs-grid>
